import React from 'react'

export default function Badge({ text = 'BETA', className = 'badge-beta' }) {
  return <span className={`badge ${className}`}>{text}</span>
}
